/**
 * Get the count of reviews for a given star rating from the review breakdown.
 * Keys follow the format: "1_star", "2_star", etc.
 */
export function getRatingCount(
  rating: number,
  reviewBreakdown?: Record<string, number> | null
): number {
  return reviewBreakdown?.[`${rating}_star`] ?? 0
}

/**
 * Returns true if a rating filter button should be disabled (no reviews for that rating).
 * Only disabled when reviewBreakdown is provided and the count is 0.
 */
export function isRatingDisabled(
  rating: number,
  reviewBreakdown?: Record<string, number> | null
): boolean {
  return (
    reviewBreakdown != null && getRatingCount(rating, reviewBreakdown) === 0
  )
}

/**
 * Returns true when the breakdown has at least one review to filter by.
 * Use this to hide the rating filters when breakdown is empty (all zeros) or missing,
 * e.g. due to sync issues where avg/total exist but breakdown has no data.
 */
export function hasReviewBreakdownData(
  reviewBreakdown?: Record<string, number> | null
): boolean {
  if (!reviewBreakdown) return false
  const total = [1, 2, 3, 4, 5].reduce(
    (sum, r) => sum + getRatingCount(r, reviewBreakdown),
    0
  )
  return total > 0
}
